import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import jobs from '../../../data/jobs';
import ApplyPopup from '../../../components/ApplyPopup';

export default function JobDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);

  const job = jobs.find(j => j.id === id);

  if (!job) {
    return (
      <div className="p-6 text-red-500 text-center text-lg font-semibold">
        Job not found!
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white text-gray-800 px-4 md:px-10 lg:px-20 py-6">
      
      <div className="bg-black text-white py-16 text-center rounded-md mb-8 shadow">
        <h1 className="text-3xl md:text-4xl font-bold">{job.title}</h1>
        <p className="mt-2 text-sm md:text-base">{job.location}</p>
      </div>

   
      <p className="text-sm text-gray-600 mb-8">
        <span className="font-medium">ID:</span> {job.id} • {job.designation} • {job.department} • {job.experience} • <span className="font-medium">Posted:</span> {job.postedDate}
      </p>

     
      <section className="mb-6">
        <h3 className="font-semibold text-lg mb-1">Description</h3>
        <p>{job.description}</p>
      </section>

     
      <section className="mb-6">
        <h3 className="font-semibold text-lg mb-1">Skills</h3>
        <ul className="list-disc ml-6">
          {job.skills?.map((skill, index) => (
            <li key={index}>{skill}</li>
          ))}
        </ul>
      </section>

     
      <section className="mb-8">
        <h3 className="font-semibold text-lg mb-1">Responsibilities</h3>
        <ul className="list-disc ml-6">
          {job.responsibilities?.map((resp, index) => (
            <li key={index}>{resp}</li>
          ))}
        </ul>
      </section>

      
      <div className="flex gap-4 mb-10">
        <button
          onClick={() => navigate(-1)}
          className="px-4 py-2 border border-blue-600 text-blue-600 rounded hover:bg-blue-600 hover:text-white transition text-sm"
        >
          Back
        </button>
        <button
          onClick={() => setShowPopup(true)}
          className="px-4 py-2 border border-blue-600 text-blue-600 rounded hover:bg-blue-600 hover:text-white transition text-sm"
        >
          Apply Now
        </button>
      </div>

     
      {showPopup && <ApplyPopup job={job} onClose={() => setShowPopup(false)} />}
    </div>
  );
}
